import { SortDirection } from '@lmt/shared-types';

export type Sorting = {
  field?: string;
  direction?: SortDirection;
};

export type Pagination = {
  page: number;
  perPage: number;
};

export enum PageSize {
  Small = 25,
  Medium = 50,
  Big = 100,
}
